import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { forwardRef } from 'react';
import cn from 'classnames';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledButton = /*#__PURE__*/styled.button.withConfig({
  componentId: "sc-4f0r04-0"
})(["\n  width: ", "px;\n  height: ", "px;\n  & > svg {\n    width: ", "px;\n    height: ", "px;\n  }\n  &:disabled {\n    cursor: not-allowed;\n  }\n"], function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var size = _ref2.size;
  return size;
}, function (_ref3) {
  var size = _ref3.size;
  return size;
}, function (_ref4) {
  var size = _ref4.size;
  return size;
});
/* This component doesn't use local contexts because it can be directly imported from outside */
var ControlButton = function ControlButton(_ref5, ref) {
  var _icon$size;
  var className = _ref5.className,
    isActive = _ref5.isActive,
    icon = _ref5.icon,
    onClick = _ref5.onClick,
    disabled = _ref5.disabled,
    ariaLabel = _ref5['aria-label'],
    isSm = _ref5.isSm;
  var buttonClassName = cn('button-base flex-shrink-0', _defineProperty(_defineProperty({}, isActive ? 'text-secondary-light' : 'text-white', !disabled), 'text-gray-main', disabled), className);
  var Icon = icon.component;
  var size = (_icon$size = icon.size) !== null && _icon$size !== void 0 ? _icon$size : isSm ? 32 : 24;
  var buttonProps = {
    className: buttonClassName,
    ref: ref,
    'aria-label': ariaLabel,
    size: size
  };
  if (onClick) {
    return /*#__PURE__*/_jsx(StyledButton, _objectSpread(_objectSpread({
      type: "button",
      onClick: onClick,
      disabled: disabled
    }, buttonProps), {}, {
      children: /*#__PURE__*/_jsx(Icon, {
        className: "tw-fill-current tw-flex-shrink-0",
        ignoreColor: true
      })
    }));
  }
  return /*#__PURE__*/_jsx(StyledButton, _objectSpread(_objectSpread({
    as: "span"
  }, buttonProps), {}, {
    children: /*#__PURE__*/_jsx(Icon, {
      className: "tw-fill-current tw-flex-shrink-0",
      ignoreColor: true
    })
  }));
};
export default /*#__PURE__*/forwardRef(ControlButton);